import './payment.scss';
import Payment from "./PaymentComponents";
import Back from "../../../components/UI/Back/Back";
import {useNavigate, useParams} from "react-router-dom";
import Dropdown from "../../../components/UI/Dropdown";
import PaymentSignUp from "./PaymentComponents/SignUp";
import React, {useContext, useEffect} from "react";
import {UserContext} from "../../../hooks/Context/UserContext";
import {useQueryCart} from "../../../api/payment/useQueryCart";
import {PortfolioContext} from "../../../hooks/Context/PortfolioContext";
import PaymentSummary from "./PaymentComponents/Summary";
import Loading from "../../../components/UI/Loading/Loading";
import ButtonKMQ from "../../../components/UI/Button/ButtonKMQ";
import {useFreePayment} from "../../../api/payment/useFreePayment";
import {ButtonTypes} from "../../../constants/ui/types/ButtonTypes";
import PaymentAccount from "./PaymentComponents/Account";

const PaymentPage = () => {
  const [user] = useContext(UserContext);
  const navigate = useNavigate();
  const {session_id} = useParams();
  const [portfolio] = useContext(PortfolioContext);

  const {data: cartData, refetch: refetchCart, isPending} = useQueryCart({
    portfolio_id: portfolio?.id ? portfolio.id : localStorage.getItem('portfolio_id'),
    payment_intent_id: session_id
  });
  const {mutate: makeFreePayment, isSuccess, isPending: paymentPending} = useFreePayment({
    portfolio_id: portfolio?.id ? portfolio.id : localStorage.getItem('portfolio_id'),
    payment_intent_id: session_id
  });

  useEffect(() => {
    if (isSuccess) {
      navigate('/cpl-applicant/my-programs');
    }
  }, [isSuccess])

  useEffect(() => {
    window.scroll(0, 0);
  }, [])

  return <div className={'payment'}>
    <Loading loading={isPending || paymentPending}/>
    <Back
      text={'Back to My Cart'}
      onClick={() => navigate(`/cpl-applicant/${user.isSoft ? 'cart' : 'cart'}`)}
    />

    <div className={'payment-container'}>
      <div className={'payment-left'}>
        <div className={'payment-left-title'}>
          Checkout
        </div>
        {user.isSoft
          ? <Dropdown title={'Create Account'} defaultOpened>
            <PaymentSignUp/>
          </Dropdown>
          : <Dropdown title={'My Account'} defaultOpened>
            <PaymentAccount/>
          </Dropdown>
        }
        <Dropdown title={'Payment Information'} defaultOpened={!user.isSoft}>
          {cartData?.total > 0.5
            ? <Payment
              refetchCart={refetchCart}
            />
            : <div className={'payment-left-free'}>
              <ButtonKMQ onClick={makeFreePayment} type={ButtonTypes.Tertiary}>
                Pay now
              </ButtonKMQ>
            </div>
          }
        </Dropdown>
      </div>

      <div className={'payment-right'}>
        <PaymentSummary
          cartData={cartData}
          refetchCart={refetchCart}
        />
      </div>
    </div>
  </div>
}

export default PaymentPage;